export { default } from "./useLazyContentPromotionFormQuestionsGet";
